import { createFileRoute } from '@tanstack/react-router';
import { SpaceLayout } from '@/app/shell/space-layout';

/** Shared and external spaces (/s/$spaceId/…): the app shell around every page, outside any organisation. */
export const Route = createFileRoute('/_auth/s/$spaceId')({
  component: SpaceLayout,
});
